import { render } from "./List_Packs.vue?vue&type=template&id=04e8549c"
import script from "./List_Packs.vue?vue&type=script&lang=js"
export * from "./List_Packs.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__